import React from 'react';
import PropTypes from 'prop-types';
import { Flex, Text } from 'rebass/styled-components';

export const CustomFieldSingleSelectRowRenderer = ({ value, ...props }) => (
  <Flex
    sx={{
      width: '100%',
      height: '28px',
      alignItems: 'center',
      py: '4px',
    }}
    {...props}
  >
    <Text
      flexGrow={1}
      fontSize="14px"
      pr="32px"
      className="ag-rich-select-row-custom-text"
      sx={{
        whiteSpace: 'nowrap',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        color: 'text.main',
        lineHeight: '20px',
      }}
    >
      {value.label}
    </Text>
  </Flex>
);

CustomFieldSingleSelectRowRenderer.propTypes = {
  value: PropTypes.string,
};

CustomFieldSingleSelectRowRenderer.defaultProps = {
  value: '',
};
